// extracted by mini-css-extract-plugin
module.exports = {"trayButton":"traybutton_trayButton__9kCaP","active":"traybutton_active__1P7ZN"};